export default [
  {
    path: "/",
    component: () => import("@/pages/auth/auth-login.vue"),
  },
  {
    path: "*",
    component: () => import("@/pages/auth/auth-login.vue"),
  },
  {
    path: "/forbidden",
    component: () => import("@/pages/auth/auth-forbidden.vue"),
  },
  {
    path: "/login",
    component: () => import("@/pages/auth/auth-login.vue"),
  },
  {
    path: "/forgot-password",
    component: () => import("@/pages/auth/auth-forgot-password.vue"),
  },
  {
    path: "/reset-password",
    name: "reset-password",
    component: () => import("@/pages/auth/auth-reset-password.vue"),
  },
  {
    path: "/two-factor-auth",
    name: "two-factor-auth",
    component: () => import("@/pages/auth/auth-two-factor.vue"),
    meta: { requiresOTP: true },
  },
];
